module.exports = __webpack_public_path__ + "static/img/bg26.32b5b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg26.jpg
// module id = s2qW
// module chunks = 1